import {Component} from '@angular/core';
import {Store} from '@ngrx/store';
import {AppState} from '../../shared/store/store';
import {Observable} from 'rxjs';
import {map} from 'rxjs/operators';
import {Serializer} from '../../shared/interfaces/serializer';
import {Site} from '../../shared/interfaces/site';
import {selectInitIsLoaded, selectSite} from '../../shared/store/init/init.selectors';

@Component({
  selector: 'app-public-reports-layout',
  templateUrl: './public-reports-layout.component.html',
  styleUrls: ['./public-reports-layout.component.scss']
})
export class PublicReportsLayoutComponent {

  public readonly isLoaded$: Observable<boolean> = this._store.select(selectInitIsLoaded);
  public readonly dataset$: Observable<Serializer<Site>> = this._store.select(selectSite);
  public readonly image$: Observable<string> = this.dataset$.pipe(
    map((dataset: Serializer<Site>) => dataset.attributes.parameters.image)
  );

  constructor(
    private readonly _store: Store<AppState>
  ) {}

}
